// extracted by mini-css-extract-plugin
export default {"workingContent":"WorkingContent_workingContent__IMHfo","info":"WorkingContent_info__wlqzO","desc":"WorkingContent_desc__vOpNV"};